import { customerData } from '../../../utilities/CustomerData'

export default function DashboardProgress() {
  return (
    <div className='w-full flex flex-col items-center mb-10'>
      {customerData.customerLeadData.leadStage.leadStageId === '36361e99-41da-46bc-b559-67078e125228' && (
        <div className='w-full flex flex-col items-center gap-2'>
          <div className='w-full bg-white h-16 rounded-full overflow-hidden relative'>
            <div className='h-full bg-[#C91515] w-[80%] rounded-r-full'></div>
            <span className='absolute inset-0 flex justify-center text-2xl items-center font-bold text-white'>
              80% Complete
            </span>
          </div>
        </div>
      )}
      {customerData.customerLeadData.leadStage.leadStageId === 'bc2d9deb-5441-4711-a74c-46db4ba563b5' && (
        <div className='w-full flex flex-col items-center gap-2'>
          <div className='w-full bg-white h-16 rounded-full overflow-hidden relative'>
            <div className='h-full bg-[#C91515] w-[90%] rounded-r-full'></div>
            <span className='absolute inset-0 flex justify-center text-2xl items-center font-bold text-white'>
              90% Complete
            </span>
          </div>
        </div>
      )}
    </div>
  )
}